// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LaSr","colBig":"styles_colBig__3yMR8","colSmall":"styles_colSmall__IP02j","shopifyNameWrapper":"styles_shopifyNameWrapper__3E3lD"};